<template>
  <div class="row">
    <card
      type="tasks"
      class="col-sm"
      style="height: auto; padding-bottom: 30px; overflow-x: auto"
    >
      <template slot="header">
        <div style="">
          <div class="row">
            <div class="">
              <h4 class="title d-inline">在线支付</h4>
            </div>
          </div>
        </div>
        <div style="margin-top: 20px">
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div>
                <el-select
                  class="select-danger"
                  style="width: 200px"
                  placeholder="请选择"
                  v-model="payInfoSelects.simple"
                  @change="handleSelectsChange"
                >
                  <el-option
                    v-for="option in payInfoSelects.languages"
                    class="select-danger"
                    :value="option.value"
                    :label="option.label"
                    :key="option.label"
                  >
                  </el-option>
                </el-select>

                <el-select
                  class="select-primary mb-3 pagination-select"
                  v-model="pagination.perPage"
                  placeholder="Per page"
                  style="margin-left: 10px"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </div>

              <base-input>
                <el-input
                  @blur="onBlur"
                  type="search"
                  class="mb-3 search-input"
                  prefix-icon="el-icon-search"
                  placeholder="搜索用户名或网站订单号"
                  v-model="searchQuery"
                  aria-controls="datatables"
                >
                </el-input>
              </base-input>
            </div>
            <el-table :data="queriedData">
              <el-table-column label="支付id" prop="id" :min-width="100">
              </el-table-column>
              <el-table-column label="用户名" prop="username" :min-width="160">
              </el-table-column>
              <!-- <el-table-column
                label="套餐id"
                prop="package_id"
                :min-width="100"
              >
              </el-table-column> -->
              <el-table-column
                label="套餐名称"
                prop="package_name"
                :min-width="200"
              >
              </el-table-column>

              <el-table-column label="套餐价格" prop="price" :min-width="80">
                <template slot-scope="{ row }">
                  <badge type="default">{{ row.price }}</badge>
                </template>
              </el-table-column>

              <el-table-column label="支付ip" prop="pay_ip" :min-width="140">
              </el-table-column>
              <el-table-column
                label="网站订单号"
                prop="order_no"
                :min-width="240"
              >
              </el-table-column>
              <el-table-column
                label="对接支付订单号"
                prop="trade_no"
                :min-width="220"
              >
              </el-table-column>

              <el-table-column
                label="支付状态"
                prop="pay_state"
                :min-width="80"
              >
                <template slot-scope="{ row }">
                  <badge type="success" v-if="row.pay_state == 1">已支付</badge>
                  <badge type="danger" v-if="row.pay_state == 0">未支付</badge>
                </template>
              </el-table-column>

              <el-table-column label="支付方式" prop="pay_type" :min-width="80">
                <template slot-scope="{ row }">
                  <badge type="default" v-if="row.pay_type == 1">微信</badge>
                  <badge type="info" v-if="row.pay_type == 0">支付宝</badge>
                </template>
              </el-table-column>

              <el-table-column
                label="创建时间"
                prop="create_time"
                :min-width="180"
                :formatter="timeFormatter"
              >
              </el-table-column>

              <!-- align="center" 需要表格居中加上这个属性-->

              <el-table-column
                label="支付时间"
                prop="pay_time"
                :min-width="180"
                :formatter="timeFormatter"
              >
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                显示 {{ from + 1 }} 到 {{ to }} 总数 {{ total }} 条
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </div>
      </template>
    </card>
  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "../../components";
import Swal from "sweetalert2";
import { http } from "../../util/http.js";
import { changeDateFormat, checkTime } from "../../util/utils.js";
import Badge from "@/components/Badge";
import Modal from "@/components/Modal";
import BaseTable from "@/components/BaseTable";

export default {
  components: {
    Badge,
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  computed: {
    queriedData() {
      return this.tableData;
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.pagination.total;
    },
  },
  data() {
    return {
      payInfoSelects: {
        simple: "5",
        languages: [
          { value: "5", label: "全部支付类型" },
          { value: "1", label: "已支付" },
          { value: "0", label: "未支付" },
        ],
      },
      checkTime,
      changeDateFormat,
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      blurredSearchQuery: "",
      propsToSearch: ["cdk", "email", "age"],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
    };
  },
  methods: {
    // 单选框选择事件
    handleSelectsChange(value) {
      // console.log("当前选择的值:", value);
      localStorage.setItem("payInfoSelectStoreId", value);
      this.handleCurrentChange();
    },
    onBlur() {
      // 当输入框失去焦点时，改变 blurredSearchQuery 的值
      this.blurredSearchQuery = this.searchQuery;
    },
    // 获取所有用户信息
    handleCurrentChange() {
      let payInfoSelectStoreId = localStorage.getItem("payInfoSelectStoreId");
      if (payInfoSelectStoreId) {
        this.payInfoSelects.simple = payInfoSelectStoreId;
      } else {
        this.payInfoSelects.simple = "5";
        localStorage.setItem("payInfoSelectStoreId", "5");
        payInfoSelectStoreId = "5";
      }

      http
        .post(
          "/v1/admin/getAllOrder",
          {
            currentPage: this.pagination.currentPage,
            perPage: this.pagination.perPage,
            searchQuery: this.searchQuery,
            storeId: payInfoSelectStoreId,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 2000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }

          this.pagination.total = res.data.data.total;
          this.tableData = res.data.data.userPay;
        })
        .catch((error) => {
          console.error("发生错误:", error);
        });
    },
    timeFormatter(row, column, cellValue) {
      // 在这里处理你的数据
      // row 是整个行数据
      // column 是列数据
      // cellValue 是单元格的值
      // 例如你想将名字转为大写形式：
      if (cellValue == "0001-01-01T00:00:00Z") {
        return "";
      } else {
        cellValue = changeDateFormat(cellValue);
        return cellValue;
      }
    },
  },
  mounted() {
    this.handleCurrentChange();
  },
  watch: {
    blurredSearchQuery(newVal, oldVal) {
      // 监控搜索
      if (newVal == "") {
        this.handleCurrentChange();
        return;
      }
      this.handleCurrentChange();
    },
    "pagination.currentPage"(newPage, oldPage) {
      // 监控翻页
      // 这里进行你的数据请求等操作
      this.handleCurrentChange();
    },
    "pagination.perPage"(newPage, oldPage) {
      // 监控翻页
      // 这里进行你的数据请求等操作
      this.handleCurrentChange();
    },
  },
};
</script>
<style scoped lang="scss" >
.pagination-select,
.search-input {
  width: 200px;
}
::v-deep .modal-dialog {
  max-width: 2200px !important;
  margin: 5.2rem auto !important;
}
</style>
